var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckeditor"},[_c('div',{attrs:{"id":_vm.id}}),_c('div',{staticClass:"image-choose",attrs:{"id":"image-choose"},on:{"click":_vm.imageChoose}}),(_vm.show_attachment)?_c('components-attachment',{attrs:{"accept":_vm.accept_list},on:{"close":function($event){_vm.show_attachment = false},"choose":_vm.choose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }